import RecommendationApiWarning from '@/models/RecommendationApiWarning';

export type RecommendationWarningModifier = 'already-viewed' | 'tag-notified' | null;

const isAdminOnlyRecommendationWarning = (warning: RecommendationApiWarning) => (
  warning === RecommendationApiWarning.PROJECT_ALREADY_VIEWED
  || warning === RecommendationApiWarning.PROJECT_ALREADY_NOTIFIED_BY_TAG
);

export const filterRecommendationWarning = (
  warning: RecommendationApiWarning | null,
  isAdmin: boolean,
) => {
  if (warning && isAdminOnlyRecommendationWarning(warning) && !isAdmin) return null;
  return warning;
};

export const getRecommendationWarningModifier = (
  warning: RecommendationApiWarning | null,
): RecommendationWarningModifier => {
  if (warning === RecommendationApiWarning.PROJECT_ALREADY_VIEWED) return 'already-viewed';
  if (warning === RecommendationApiWarning.PROJECT_ALREADY_NOTIFIED_BY_TAG) return 'tag-notified';
  return null;
};
